// extracted by mini-css-extract-plugin
export default {"f":"_3452aa9c55","main":"be7e809891","btn":"c18c357e63","w":"_46877d117d","h":"bd687f5ec6","lh25":"_80928eef99","wb":"dbeac934c6","b":"_35677b5fb9","bx":"ff389d4539"};